import { AccountInfo } from '@azure/msal-browser';

export const preserveAccountReference = (
  currentAccount: AccountInfo | undefined,
  nextAccount: AccountInfo | undefined
): AccountInfo | undefined =>
  currentAccount?.homeAccountId === nextAccount?.homeAccountId ? currentAccount : nextAccount;
